import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { SelectInput, TextArea, TextInput } from '../../components/FormComponents';
import PageTitle from '../../components/PageTitle';
import Popup from '../../components/Popup';
import Table from '../../components/Table';
import FeatherIcon from 'feather-icons-react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { VerticalForm } from '../../components';

const API = process.env.REACT_APP_CLIENT_IP;

function ProductPage() {
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })
    const [showPop, setShowPop] = useState({ show: false, dataId: '' })

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [productTypeData, setProductTypeData] = useState([]);
    const [inputData, setInputData] = useState({});
    const [validated, setValidated] = useState({ progress: false, login: false });

    const columns = [
        {
            Header: 'Package Code',
            accessor: 'productId',
            sort: true,
        },{
            Header: 'Package Category',
            accessor: 'productTypeName',
            sort: true,
        },
        {
            Header: 'Package Name',
            accessor: 'productName',
            sort: true,
        },
        {
            Header: 'Package Price',
            accessor: 'productPrice',
            sort: false,
        },
        {
            Header: 'Description',
            accessor: 'description',
            sort: false,
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShow(true); setInputData(original);
                    }} style={{ cursor: 'pointer' }} className="icon-dual-info" icon="edit-2" />
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />
                </div>
            }
        }
    ];

    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const schema = yup.object().shape({
        productTypeId: yup.string().ensure().required("product type is required!"),
        productName: yup.string().required("product name is required!"),
        productPrice: yup.string().required("product price is required!"),
    })

    const schemaResolver = yupResolver(schema);

    const handleChange = (event) => {
        const { name, value } = event.target
        setInputData({
            ...inputData, [name]: value
        })
        if ((name === 'productName' && value !== '') || (name !== 'productPrice' && value !== '')) {
            setValidated({ ...validated, [name]: false });
        } else { setValidated({ ...validated, [name]: true }); }
    }

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/product/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
        }
    }

    const getProductTypes = async () => {
        try {
            let arr = []
            let resp = await fetch(`${API}/api/producttype/list`).then(response => response.json());
            if (resp.success) {
                let result = resp.data;
                console.log(result);
                result.map((user) => {
                    return arr.push({ value: user.productTypeId, label: user.productTypeName });
                });
                setProductTypeData(arr);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let isValid = schema.validateSync(inputData)
            if (isValid) {
                if (inputData.productId === 0 || inputData.productId === undefined) {
                    inputData.productId = undefined;
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/product/create`, {
                            method: 'POST',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Saved Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" })
                        }
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    const data = JSON.stringify(inputData);
                    try {
                        let res = await fetch(`${API}/api/product/${inputData.productId}`, {
                            method: 'PUT',
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: data
                        }).then(response => response.json());
                        if (res.success) {
                            setNotify({ show: true, variant: 'success', message: 'Updated Successfully!' })
                            setInputData({})
                            fetchRecords();
                            handleClose();
                            setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
                        } else {
                            setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" });
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }
        } catch (error) {
            error && setValidated({ productName: true, productTypeName: true, productPrice: false });
        }
    };

    const onDelete = async (id) => {
        try {
            let res = await fetch(`${API}/api/product/${id}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { getProductTypes(); fetchRecords(); }, []);

    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Home', path: '/packagelist' },
                    { label: 'Packages/Products', path: '/packagelist', active: true },
                ]}
                title={'Packages/Products'}
            />

            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.productId)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>
            <Modal show={show} size='lg' centered>
                <Modal.Header onHide={handleClose} closeButton>
                    <p className="text-muted fs-14">
                        Fill in the required details
                    </p>
                </Modal.Header>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <VerticalForm resolver={schemaResolver} onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg={12}>
                                            <SelectInput
                                                selectTitle={'Package Type'}
                                                selectName='productTypeId'
                                                onChange={(val) => {
                                                    if (inputData.productTypeId === undefined) { setValidated({ ...validated, productTypeName: true }) }
                                                    else { setValidated({ ...validated, productTypeName: false }) }
                                                    setInputData({
                                                        ...inputData, productTypeId: val.value
                                                    })
                                                }}
                                                options={productTypeData}
                                                required={!inputData.productTypeId && validated.productTypeId}
                                                value={{ label: inputData.productTypeName, value: '' }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'Package Name'}
                                                textName='productName'
                                                onChange={handleChange}
                                                required={!inputData.productName && validated.productName}
                                                value={inputData.productName}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextInput
                                                textTitle={'Package Price'}
                                                textName='productPrice'
                                                onChange={handleChange}
                                                required={!inputData.productPrice && validated.productPrice}
                                                value={inputData.productPrice}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg={12}>
                                            <TextArea
                                                AreaTitle={'Package Description'}
                                                areaName='description'
                                                onChange={handleChange}
                                                value={inputData.description}
                                            />
                                        </Col>
                                    </Row>
                                    <Button style={{ float: 'right' }} variant="primary" type="submit" onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </VerticalForm>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">Packages/Products</h4>
                                    <p className="text-muted fs-14 mb-4">List of products</p>
                                </Col>
                                <Col xs={4}>
                                    <Button style={{ float: 'right' }} variant="success"
                                        type="submit" className="btn-sm" onClick={() => { handleShow(); setInputData({}); }}>
                                        Add New
                                        <i className='bi-plus-lg' style={{ marginLeft: '5px', fontSize: '' }}></i>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ProductPage